import { observer } from 'mobx-react';
import i_ from 'i18next';
import React from 'react';

import TextField from '../commons/TextField';
import SelectField from '../commons/SelectField';
import EditDialog from '../commons/EditDialog';
import { Row, Column } from '../commons/Containers';

import Stores from '../../stores/Stores';
import UIStore from '../../stores/UIStore';
import AuthenticationStore from '../../stores/AuthenticationStore';

const store = Stores.load('usuario');

class UsuarioEdit extends React.Component {
  componentWillMount() {
    this.perfis = Stores.create('perfil');
    this.perfis.query();
  }

  save = () => {
    if (store.edit.id != null) {
      store
        .save()
        .then(data => {
          if (this.props.onSave) {
            this.props.onSave(data);
          }
        })
        .then(() => UIStore.redo(store))
        .catch(UIStore.saveError);
    } else {
      store
        .create()
        .then(data => {
          if (this.props.onSave) {
            this.props.onSave(data);
          }
        })
        .then(() => UIStore.redo(store))
        .catch(UIStore.saveError);
    }
  };

  render() {
    this.item = store.edit != null ? store.edit : {};
    let { pesquisa } = AuthenticationStore.me;

    return (
      <EditDialog
        title={i_.t('usuario.title', {
          context: this.item.id ? 'edit' : 'new',
          label: this.item.nome,
        })}
        opened={store.edit != null}
        onCancel={() => (store.edit = null)}
        onSave={this.save}
      >
        <Row>
          <Column>
            <TextField entity="usuario" field="nome" item={this.item} />

            <TextField entity="usuario" field="email" item={this.item} />

            <TextField entity="usuario" field="telefone" item={this.item} />

            <TextField entity="usuario" field="password" item={this.item} />
          </Column>

          <Column>
            <SelectField
              entity="usuario"
              field="perfil"
              item={this.item}
              list={this.perfis.list}
              labelFunc={m => m.nome}
            />
            <SelectField
              entity="usuario"
              field="cargos"
              item={this.item}
              list={pesquisa ? pesquisa.cargos.map(c => c.cargo) : []}
              labelFunc={m => m.nome}
              multiple={true}
            />
          </Column>
        </Row>
      </EditDialog>
    );
  }
}

export default observer(UsuarioEdit);



// WEBPACK FOOTER //
// ./src/components/usuario/Edit.js